import { liteClient as algoliasearch } from 'algoliasearch/lite';

import React, { useMemo, useState } from 'react';
import { InstantSearch } from 'react-instantsearch';

import { Box } from 'theme-ui';
import SearchBox from './SearchBox';
import SearchResult from './SearchResult';

interface IndexType {
  name: string;
  title: string;
}

interface SearchProps {
  indices: IndexType[];
  onClose: () => void;
  hasFocus?: boolean;
}

export default function Search({ indices, onClose, hasFocus }: SearchProps) {
  const [query, setQuery] = useState<string>('');

  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID!,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY!,
      ),
    [],
  );

  return (
    <InstantSearch searchClient={searchClient} indexName={indices[0].name}>
      <SearchBox
        onChange={(query: string) => setQuery(query)}
        hasFocus={hasFocus}
        onClose={onClose}
      />

      <Box sx={{ position: 'relative', width: '100%' }}>
        <SearchResult
          show={!!query && query.length > 0 && hasFocus}
          indices={indices}
        />
      </Box>
    </InstantSearch>
  );
}
